import { createSelector } from 'reselect'

export const selectData = state => state.data
export const selectToken = createSelector(selectData, state => state.token?.mainToken)
export const selectTokenAccessStatus = createSelector(selectData, state => state.token?.status)

export {
  selectSelf,
  selectSelfCategories,
  selectSelfRoleId,
  selectAllowedCategories,
} from 'src/store/modules/self'
